module.exports = __webpack_public_path__ + "static/media/filled_bar_prewash_tall.a2757f58.svg";